export const AppLanguages = {
  en: {
    files: [
      // {
      //   url: './arco-core/assets/css/lib-ltr.css',
      //   id: 'en-arco-primeng-style',
      // },
      {
        url: './assets/css/ltr.css',
        id: 'en-ltr-css',
      },
    ],
  },
  ar: {
    files: [
      // {
      //   url: './arco-core/assets/css/lib-rtl.css',
      //   id: 'ar-link-vertical-menu-css',
      // },
      {
        url: './assets/css/rtl.css',
        id: 'en-rtl-css',
      },
    ],
  },
};
